import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { FaRegTrashAlt } from 'react-icons/fa';
import { BsDot } from 'react-icons/bs';
import { FiShare } from 'react-icons/fi';
import { ObjModal } from '../../../../contexts';
import AddReview from '../../../Modals/AddReview';
import SendEmail from '../../../Modals/SendEmail';
import Rating from '@mui/material/Rating';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { removeReview } from '../../../../common/api';
import { toast } from 'react-toastify';


const Reviews = ( { aid, uid, setTemplate } ) => {
    const nav = useNavigate();

    const { objType, obj, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );

    useEffect( () => {
        setExpanded( obj.reviews.length > 0 );
    }, [ obj.reviews ] );

    const trash = async ( raid, rid ) => {
        const removed = await removeReview( raid, uid, rid );
        if ( removed.length ) {
            toast.success( 'The review has been deleted', { theme: 'dark' } );
            // window.location.reload( false );
        }
    };

    const share = async ( rid ) => {
        // const r = obj.reviews.find( f => f.id === rid );
        // let name = '';

        // if ( objType === 'contact' ) {
        //     name = obj.details.firstname;
        //     if ( obj.details.lastname?.length ) {
        //         name += ' ' + obj.details.lastname.charAt( 0 ) + '.';
        //     }
        // } else if ( objType === 'loan' ) {

        // }
        // setTemplate( {
        //     url: window.location.pathname,
        //     tid: '63521e8993d0f07a59450a90',
        //     tr: [
        //         { key: 'headline', text: r.headline },
        //         { key: 'reviewer', text: name },
        //         { key: 'review', text: r.review }
        //     ]
        // } );

        // nav( '/marketing' );
    };

    const handleModal = ( t, rid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'review':
                setModal( <AddReview close={closeModal} objType={objType} obj={obj} /> ); 
                break;

            case 'share':
                const r = obj.reviews.find( f => f.id === rid );
                let body = '<p><blockquote style="border-left: 2px solid #CCC;">';
                body += '<div style="padding: 5px 5px 5px 10px;"><b>' + r.headline + '</b></div>';
                body += '<div style="padding: 5px 5px 5px 10px;">' + r.review + '</div>';
                body += '<div style="padding: 5px 5px 5px 10px;"><i>~&nbsp;' + obj.details.firstname + ' ' + obj.details.lastname.charAt( 0 ) + '.</i></div>';                
                body += '</blockquote></p>';
                setModal( <SendEmail close={closeModal} obj={obj} tmplContent={body} sub={`Another ${r.rating} Star Review!`} /> );
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Reviews ({obj.reviews.length})</Typography></Col>
                        <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'review' ) }>+ Add</Button></Col>
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <ListGroup variant='flush' className='overflow-scroll' style={ { maxHeight: '250px' } }>
                    { obj.reviews.map( ( r, idx ) => (
                        <ListGroup.Item key={r.id}>
                            <Row className='align-items-center'>
                                <Col xs='auto'>
                                    <Rating value={r.rating} readOnly size='small' precision={0.5} />
                                </Col>
                                <Col className='ps-0'>
                                    <Row className='align-items-center'>
                                        <Col xs='auto' className='tf-sidebar-obj-key-date-container pe-1'>
                                            <Link to={`/review/${r.rid}`}>{r.headline}</Link>
                                        </Col>
                                        <Col xs='auto' className='p-0'><BsDot /></Col>
                                        <Col xs='auto' className='p-1'>{r.reviewDate}</Col>
                                    </Row>
                                </Col>
                                <Col xs='auto'><FiShare className='tf-sidebar-share' onClick={ () => handleModal( 'share', r.id ) } /></Col>
                                <Col xs='auto'><FaRegTrashAlt className='tf-sidebar-trash' onClick={ () => trash( r.aid, r.rid ) } /></Col>
                            </Row>
                            <Row className='overflow-scroll' style={ { maxHeight: '50px' } }>
                                <Col>{r.review}</Col>
                            </Row>
                        </ListGroup.Item>
                    ) ) }
                    </ListGroup>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );

const mapDispatch = ( dispatch ) => ( {
    setTemplate: dispatch.marketing.setTemplate
} );

export default connect( mapProps, mapDispatch )( Reviews );